import { useTrackPageView } from '@/services/track';

const Terms = () => {
  useTrackPageView();

  return (
    <div>
      <h1>Terms and Conditions</h1>
      <p>Insert your terms and conditions content here.</p>
    </div>
  );
};

export default Terms;
